import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const SobreNosotros = () => {
  const [ref, isVisible] = useScrollAnimation();
  return (
    <section id="nosotros" className="text-white" style={{ backgroundColor: '#1E3A5F', paddingTop: '4rem', paddingBottom: '3rem' }}>
      <div className="container" ref={ref}>
        {/* Título para móvil - centrado */}
        <h2 className={`text-center mb-5 fw-bold d-lg-none ${isVisible ? 'animate-fade-in' : ''}`}>Sobre Nosotros</h2>
        <div className="row align-items-center g-4">
          {/* Columna izquierda - Imagen */}
          <div className="col-lg-5">
            <div className={`text-center ${isVisible ? 'animate-slide-left' : ''}`}>
              <img 
                src={`${process.env.PUBLIC_URL || ''}/images/estudio.png`}
                alt="Tránsito & Derecho - Consulta y gestión legal" 
                className="img-fluid rounded shadow sobre-nosotros-img"
                style={{ objectFit: 'cover', width: '100%' }}
              />
            </div>
          </div>

          {/* Columna derecha - Texto */}
          <div className="col-lg-7">
            {/* Título para desktop - en la columna del texto */}
            <h2 className={`d-none d-lg-block fw-bold mb-4 ${isVisible ? 'animate-slide-right' : ''}`} style={{ fontSize: '2.5rem', animationDelay: '0.2s' }}>Sobre Nosotros</h2>
            <div className={`lead ${isVisible ? 'animate-slide-right' : ''}`} style={{ animationDelay: '0.3s' }}>
              <p className="mb-4">
                Tránsito & Derecho se especializa exclusivamente en la gestión y resolución de fotomultas en todo el país.
              </p>
              <p className="mb-4">
                No solo resolvemos infracciones: trabajamos informando a las personas sobre las consecuencias legales que muchas veces desconocen al momento de pagar una multa.
              </p>
              <p className="mb-4">
                La mayoría de los casos de pago voluntario implica reconocer la infracción, generando antecedentes que pueden agravar sanciones futuras y traer consecuencias que no son evidentes al momento de decidir.
              </p>
              <p className="mb-4">
                Por eso, analizamos cada caso en profundidad para reducir o anular sanciones, evitando que esos antecedentes impacten en la situación legal del cliente.
              </p>
              <p className="mb-0">
                Brindamos soluciones rápidas, transparentes y efectivas, con seguimiento constante y atención personalizada en cada etapa del proceso.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SobreNosotros;
